import { environment } from '../../../environments/environment';
import { OnChanges, Directive, SimpleChanges } from '@angular/core';
import { Validator, NG_VALIDATORS, AbstractControl, Validators, ValidatorFn } from '@angular/forms';
import 'adyen-cse-js';
import {ConfigService} from '../service/config.service';

declare var require: any;

export function validateCreditCardData(cseInstance: any): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    if (control) {
      const numberCtrl: AbstractControl = control.get('number');
      const cvcCtrl: AbstractControl = control.get('cvc');
      const expiryMonthCtrl: AbstractControl = control.get('expiryMonth');
      const expiryYearCtrl: AbstractControl = control.get('expiryYear');

      // Number Validation
      if (numberCtrl && numberCtrl.value) {
        const validationResult = cseInstance.validate({ 'number': '' + numberCtrl.value });
        if (!validationResult['number']) {
          console.log('setting error on field: number');
          numberCtrl.setErrors({ 'ccvalidation': true });
        }
      }

      // CVC Validation
      if (cvcCtrl && cvcCtrl.value) {
        const validationResult = cseInstance.validate({ 'cvc': '' + cvcCtrl.value });
        if (!validationResult['cvc']) {
          console.log('setting error on field: cvc');
          cvcCtrl.setErrors({ 'ccvalidation': true });
        }
      }

      // Expiry Date Validation
      if (expiryMonthCtrl && expiryYearCtrl && expiryMonthCtrl.value && expiryYearCtrl.value) {
        const month: number = parseInt(expiryMonthCtrl.value, 10);
        const year: number = parseInt(expiryYearCtrl.value, 10);

        const validationResult = cseInstance.validate({ 'month': '' + month, 'year': '' + year });

        // Custom validate expiryDate
        const currentYear: number = new Date().getFullYear();
        const currentMonth: number = new Date().getMonth() + 1;
        if (year < currentYear) {
          validationResult.year = false;
          validationResult.expiryYear = false;
          validationResult.valid = false;
        } else if (year <= currentYear && month < currentMonth) {
          validationResult.month = false;
          validationResult.expiryMonth = false;
          validationResult.valid = false;
        }

        if (!validationResult['expiryMonth']) {
          console.log('setting error on field: expiryMonth');
          expiryMonthCtrl.setErrors({ 'ccvalidation': true });
        }

        if (!validationResult['expiryYear']) {
          console.log('setting error on field: expiryYear');
          expiryYearCtrl.setErrors({ 'ccvalidation': true });
        }
      }
    }

    // return isValid ? null : { 'ccvalidation': true };
    return null;
  };
}

@Directive({
  selector: '[validCreditCardData]',
  providers: [{ provide: NG_VALIDATORS, useExisting: CreditCardValidatorDirective, multi: true }]
})
export class CreditCardValidatorDirective implements Validator, OnChanges {
  private valFn = Validators.nullValidator;

  private publicKey: string;
  private cseInstance: any;

  constructor(private configService: ConfigService) {
    this.publicKey = configService.getPublicKey();

    const adyenEncrypt = require('adyen-cse-js');
    this.cseInstance = adyenEncrypt.createEncryption(this.publicKey, { enableValidations: false });

    this.valFn = validateCreditCardData(this.cseInstance);
  }

  validate(control: AbstractControl): { [key: string]: any; } {
    return this.valFn(control);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.valFn = validateCreditCardData(this.cseInstance);
  }

  registerOnValidatorChange(fn: () => void): void {
    // TODO Auto-generated method stub
    return;
  }

}
